/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../libs/Context';
import { Image } from '../../../libs/CustomHooks/Image';
const GroupAudioCallPartipate = (props) =>
{
	const { language } = useContext(LanguageContext);

	const userData = useSelector((state:any) => state?.mysession?.session);

	const selfData:any = props?.roomMembers?.find((each:any) => each?.userId === userData?.userId);

	return (
		<div className='flexMinHeightCol pdngXS scrollY'>
			<div className='flexRow alignCntr pdngXXS'>
				<div className='flexAutoRow pdngHXS'>
					<div className='imgAvatarMD brdrRadius50'>
						<div className='imgAvatarMD brdrBlackSM brdrRadius50'>
							<Image src={selfData?.thumbnailImage || selfData?.profileImage || '/images/icons/defaultUser.svg'} alt='user' className='brdrRadius50' fallback={<img src='/images/icons/defaultUser.svg' alt='fallback' className='brdrRadius50'/>}/>
						</div>
					</div>
				</div>
				<div className='flexAutoRow pdngHXS'>
					<span className='whiteLightTxt'>{language?.you}</span>
				</div>
			</div>
			{props?.roomMembers?.map((item:any) =>
			{
				const callStatusObj = {
					'call again' : 'callagainBtn',
					'in call'    : 'inCallBtn'
				};

				return (
					<div className='flexRow alignCntr pdngXXS' key={item?.userId}>
						{item?.userId !== userData?.userId &&
						<>
							<div className='flexAutoRow pdngHXS'>
								<div className='imgAvatarSM brdrRadius50'>
									<div className='imgAvatarSM brdrBlackSM brdrRadius50'>
										<Image src={item?.thumbnailImage || item?.profileImage || '/images/icons/defaultUser.svg'} className='brdrRadius50' fallback={<img src='/images/icons/defaultUser.svg' alt='fallback' className='brdrRadius50'/>}/>
									</div>
								</div>
							</div>
							<div className='flexMinWidthRow pdngHXS'>
								<span className='whiteLightTxt'>{item?.name}</span>
							</div>
							<div className='flexAutoRow pdngHXS'>
								<button className={`${callStatusObj[item?.callStatus] || 'onGoingcall'} flexRow alignCntr justifyCntr brdrRadiusXSM pointer`}
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && item?.callStatus === 'call again' && props.onCallAgain(item?.userId); }}
									onClick={() => { item?.callStatus === 'call again' && props.onCallAgain(item?.userId); }}
								>
									{item?.callStatus !== 'calling' && <span className='flexInline pdngXS upperCaseTxt'>{item?.callStatus}</span>}
									{item?.callStatus === 'calling' &&
									<div className='flexInline alignCntr justifyCntr pdngXS'>
										<span className='upperCaseTxt'>calling</span>
										<span className=''>...</span>
									</div>}
									{item?.callStatus === 'in call' &&
									<div className='wrapper2'>
										<small className='insidewrapper' />
										<small className='insidewrapper' />
										<small className='insidewrapper' />
										<small className='insidewrapper' />
									</div>}
								</button>
							</div>
						</>
						}
					</div>
				);
			}

			)}
		</div>
	);
};

export default GroupAudioCallPartipate;
